import { render, staticRenderFns } from "./LanguageChooser.vue?vue&type=template&id=2ac4cfbe&scoped=true"
import script from "./LanguageChooser.vue?vue&type=script&lang=js"
export * from "./LanguageChooser.vue?vue&type=script&lang=js"
import style0 from "./LanguageChooser.vue?vue&type=style&index=0&id=2ac4cfbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac4cfbe",
  null
  
)

export default component.exports